import articlesData from "../../data/Articles.json";
import React from "react";
import "../../styles/Articles.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
const ArticlesList = () => {
  const [articleData, setArticles] = useState({ articles: [] });
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      setArticles(articlesData);
    } catch (err) {
      console.error("Error setting articles:", err);
      setError(err.message); // Optional: set error state if you have one
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!articleData) return <p>Loading...</p>;

  return (
    <div className="articles-list">
      <h2>Articles</h2>
      <div className="articles">
        <ol>
          {articleData.articles.map((entry, index) => (
            <li key={index}>
              {entry.authors}.{" "}
              {entry.link !== "" ? (
                <Link
                  to={entry.link}
                  style={{ textDecoration: "none", color: "darkblue" }}
                >
                  {entry.title}
                </Link>
              ) : (
                entry.title
              )}
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default ArticlesList;
